import * as React from 'react';
import {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const excludeDeprecatedSelected = (defaultSelectedItems, items) => {
    return defaultSelectedItems.filter(defaultSelectedItem => items.includes(defaultSelectedItem))
}

export default function MultipleSelect(props) {
    const [state, setState] = useState(
        {
            selectedItems: props.defaultSelectedItems ?
                excludeDeprecatedSelected(props.defaultSelectedItems, props.items) : []
        })

    useEffect(() => {
        props.setSelectedItems(state.selectedItems)
    }, [state.selectedItems])


    const handleChangeAvailableLocation = (event) => {
        const value = event.target.value
        setState({...state, selectedItems: typeof value === 'string' ? value.split(',') : value})
        props.setSelectedItems(state.selectedItems)
    };
    return (
        <FormControl fullWidth size={props.size || "small"}>
            <InputLabel
                id={props.labelId}>
                {props.label}
            </InputLabel>
            <Select
                labelId={props.labelId}
                id={`${props.labelId}-multiple-checkbox`}
                multiple
                value={state.selectedItems}
                onChange={handleChangeAvailableLocation}
                input={<OutlinedInput label={props.label}/>}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
            >
                {props.items && props.items.map((item) => (
                    <MenuItem key={`${props.label}_${item}`}
                              value={item}>
                        <Checkbox checked={state.selectedItems.indexOf(item) > -1}/>
                        <ListItemText primary={item}/>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

MultipleSelect.propTypes = {
    label: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    defaultSelectedItems: PropTypes.array,
    setSelectedItems: PropTypes.func.isRequired,
    size: PropTypes.oneOf(["small", "medium"])
}